export default __webpack_public_path__ + "static/media/pantry1-afterB-480w.169b1e00.webp";